import { onDomReady } from './on-dom-ready';

function onChangeEventSubmit(this: HTMLInputElement | HTMLSelectElement) {
  this.form?.submit();
}

onDomReady(() => {
  for (const element of document.querySelectorAll<
    HTMLInputElement | HTMLSelectElement
  >('input[type="checkbox"].toggle-switch, select.multi-select-menu')) {
    switch (element.getAttribute('data-behavior')) {
      default:
        break;
      case 'onchange-submit':
        element.addEventListener('change', onChangeEventSubmit);
        break;
    }
  }
});
